import gql from 'graphql-tag'

/**
 * Query
 */
const GET_PLAME_REPORT_BY_FILTER = gql`
  query getPlameReportByFilter($year: Int!, $month: Int!) {
    getPlameReportByFilter(year: $year, month: $month) {
      id
      year
      month
      items {
        id
        report_plame_id
        employee_id
        employee {
          id
          name
          last_name
          mothers_last_name
          fullLastName
          fullName
          document_type
          document_number
          plame {
            ensures_pension
            essalud
            domiciled
          }
        }
      }
      created_at
      updated_at
      deleted_at
    }
  }
`
/**
 * Mutations
 */
const GENERATE_PLAME_REPORT = gql`
  mutation generatePlameReport($year: Int!, $month: Int!) {
    generatePlameReport(year:$year, month: $month) {
      employee_id
      employee {
        name
        last_name
        mothers_last_name
        fullName
        id
        document_type
        document_number
      }
      ruc
      amount_received
      ensures_pension
      essalud
      fdsa
      domiciled
      rate_type
      rate
      hours_worked
    }
  }
`

export {
  GENERATE_PLAME_REPORT,
  GET_PLAME_REPORT_BY_FILTER
}
